import React from "react";

import {CgClose, CgMinimize, CgMaximize} from "react-icons/cg";

import c from "../etc/Const";

import {FaRegWindowMinimize, FaRegWindowMaximize, FaWindowClose} from "react-icons/fa";


const Windowheader = ({close, headline, minimize, min, id, edit, onContext}) => {

    const bgc = {
        alignItems: 'center',
        padding: '5px',
        display: 'flex',
    }


    let _color = 'rgb(197,180,119)'
    const _background = edit ? '#e70202' : '#4f4f4f'

    return (
        <div
            onContextMenu={onContext}
            style={{
                width: '100%', //min?'180px':'100%',
                borderTop: '1px, solid, black',
                borderLeft: '1px, solid, black',
                borderRight: '1px, solid, black',
                display: 'flex',
                height: c.p2 + 'px',
                zIndex: 12,
                background: _background,
                color: _color,
                fontSize: '12px',
                fontWeight: 'bold',
                cursor: 'default',

                alignItems: 'center',
                //justifyContent: 'center',
            }}
        >


            <div style={{
                ...bgc,
                paddingRight: '+10px',
                float: 'left',
            }} className="handle">{headline}</div>


            {close ? <div style={{
                ...bgc,
                position: 'absolute',
                right: 2,
                padding: 0,
            }} onClick={() => close(false)}><CgClose/></div> : null}

        </div>
    )
}
/*
<div style={{
    ...bgc,
    position: 'absolute',
    right: 20,
    padding: 0,
}} onClick={minimize}>{min ? <FaRegWindowMaximize/> : <FaRegWindowMinimize/>}</div>
*/

export default Windowheader;